export default "__VITE_ASSET__6bbf4386__"